import Vue from 'vue'
import Vuex from 'vuex'
import http from '../utils/http'
import * as types from './types'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    news_list: [],
    total: 0,
  },
  mutations: {
    [types.GETLIST] (state, data) {
      state.news_list = data.data.list
      state.total = data.data.total
    },
  },
  actions: {
    [types.GETLIST] (context, params) {
      http.fetch('/news/index', params).then(data => {
        context.commit('getList', data)
      })
    },
  },
  modules: {
  }
})
